<div class="landing-wrapper">

  <header class="hero-section">
    <div class="hero-content">
      <span class="tag-new fadeInDown" appVisibility>Nueva Modalidad 2026</span>
      <h1 class="fadeInDown" appVisibility>La forma inteligente de enviar tus paquetes</h1>
      <p class="fadeInUp" appVisibility>Olvídate de pagar tarifas variables. Compra tus guías por volumen, congela el
        precio y úsalas cuando quieras durante todo un año.</p>
      <div class="hero-buttons fadeInUp" appVisibility>
        <button (click)="scrollTo('pricing-area')" class="btn-primary">Ver Paquetes</button>
        <button (click)="scrollTo('como-funciona')" class="btn-outline">¿Cómo funciona?</button>
      </div>
    </div>
    <div class="hero-visual swiper-hero-visual">
      <!-- TABS -->
      <div class="tabs-wrapper hero-tabs">
        <div class="section-divider fadeIn" appVisibility>
          <span>Elige tu volumen</span>
        </div>
        <div class="tabs-container fadeInUp" appVisibility>
          <button class="tab-pill" [class.active]="activeTab === '1kg'" (click)="setTab('1kg')">📦 Hasta 1 KG</button>
          <button class="tab-pill" [class.active]="activeTab === '5kg'" (click)="setTab('5kg')">📦 Hasta 5 KG</button>
          <button class="tab-pill" [class.active]="activeTab === 'heavy'" (click)="setTab('heavy')">{{ heavyTabLabel
            }}</button>
        </div>
      </div>

      <!-- SWIPER CONTAINER -->
      <div class="swiper-container swiper-pricing-hero" *ngIf="swiperReady">
        <div class="swiper-wrapper">
          <div class="swiper-slide" *ngFor="let item of allPackages">
            <article class="price-card" [class.popular-card]="item.isPopular"
              [class.not-popular-card]="!item.isPopular">
              <div class="card-badge main-badge" *ngIf="item.savings || item.isPopular">
                {{ item.savings || 'Más Vendido' }}
              </div>
              <div class="card-badge normal-badge" *ngIf="item.name === 'Crecimiento'"
                style="text-transform: none; font-size: 0.55rem; width: auto; text-align: center; line-height: 1.1; top: 17px; left: 50%; right: auto; transform: translateX(-50%); white-space: nowrap; background: #ffe0d6; color: #f05a28; padding: 4px 10px; border-radius: 12px; border: none;">
                8 de cada 10 clientes eligen este paquete
              </div>
              <div class="card-top">
                <h3 class="pkg-name">{{ item.name }}</h3>
                <div class="pkg-qty">
                  <span>{{ item.quantity }} Guías</span>
                </div>
                <div class="pkg-weight-desc">
                  {{ item.weightDesc === '10 kg' ? 'Carga Pesada +10kg' : 'Hasta ' + item.weightDesc }}
                </div>
              </div>
              <div class="card-price">
                <p class="label">Costo unitario</p>
                <div class="big-price">
                  <span class="currency">$</span>{{ item.priceUnit | number:'1.0-2' }}
                </div>
                <p class="total-price">Inversión: ${{ item.totalPrice | number:'1.0-2' }}</p>
              </div>
              <div class="card-actions">
                <a [routerLink]="['/guias-web']" [queryParams]="{ sku: item.sku }" class="btn-select">
                  Comprar Pack
                </a>
              </div>
              <div class="card-features">
                <span><i class="check-icon">✓</i> Vigencia 12 meses</span>
                <span><i class="check-icon">✓</i> Recolección Incluida</span>
                <button class="btn-details" (click)="openDetails(item)">
                  Ver detalles
                </button>
              </div>
            </article>
          </div>
        </div>
      </div>

      <!-- <div class="hero-pricing-footer fadeInUp" appVisibility
        style="text-align: center; position: relative; z-index: 10; margin-top: 20px;">
        <button (click)="scrollTo('pricing-area')" class="btn-outline"
          style="padding: 10px 25px; font-size: 0.95rem;">Ver todos los planes</button>
      </div> -->
    </div>
  </header>

  <section class="comparison-section">
    <div class="container">
      <div class="text-center">
        <h2 class="fadeInUp" appVisibility>¿Por qué cambiarte a Guías Web?</h2>
        <p class="section-subtitle fadeInUp" appVisibility>La logística tradicional te quita tiempo. Nosotros te lo
          devolvemos.</p>
      </div>

      <div class="vs-grid">
        <div class="vs-card old-way fadeInUp" appVisibility>
          <h3>❌ Envíos Tradicionales</h3>
          <ul>
            <li>Hacer fila en sucursal cada vez.</li>
            <li>Pagar precios de mostrador (más altos).</li>
            <li>Llenar datos a mano en el mostrador.</li>
            <li>Sin control digital de tus gastos.</li>
          </ul>
        </div>

        <div class="vs-icon">VS</div>

        <div class="vs-card new-way fadeInUp" appVisibility>
          <h3>✅ Guías Web Tufesa</h3>
          <ul>
            <li><strong>Drop-off Rápido:</strong> Llegas y entregas.</li>
            <li><strong>Precio Mayorista:</strong> Ahorras hasta 30%.</li>
            <li><strong>Plataforma Web:</strong> Generas guías en segundos.</li>
            <li><strong>Facturación:</strong> Automática y organizada.</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section id="como-funciona" class="steps-section">
    <div class="container">
      <h2 class="fadeIn" appVisibility>Tan fácil como 1, 2, 3</h2>

      <div class="steps-grid">
        <div class="step-item fadeInUp" appVisibility>
          <div class="step-number">1</div>
          <div class="step-icon">🛒</div>
          <h3>Compra tu Pack</h3>
          <p>Elige el paquete que se ajuste a tu volumen mensual (10, 50 o 100 guías).</p>
        </div>

        <div class="step-line"></div>
        <div class="step-item fadeInUp" appVisibility>
          <div class="step-number">2</div>
          <div class="step-icon">💻</div>
          <h3>Genera la Guía</h3>
          <p>Entra a tu panel, pon los datos del destinatario e imprime la etiqueta.</p>
        </div>

        <div class="step-line"></div>

        <div class="step-item fadeInUp" appVisibility>
          <div class="step-number">3</div>
          <div class="step-icon">🚛</div>
          <h3>Entrega Express</h3>
          <p>Pega la etiqueta en tu caja y déjala en mostrador sin hacer filas.</p>
        </div>
      </div>
    </div>
  </section>

  <section class="use-cases-section">
    <div class="container">
      <div class="text-center">
        <h2 class="fadeIn" appVisibility>Ideal para tu negocio</h2>
        <p class="section-subtitle fadeIn" appVisibility>Mira quiénes ya están ahorrando con este modelo.</p>
      </div>

      <div class="cases-grid">
        <div class="case-card ecommerce fadeInUp" appVisibility>
          <div class="card-accent"></div>
          <div class="case-content">
            <h3>🛍️ Para E-Commerce</h3>
            <blockquote class="quote-box">
              "Vendo ropa y zapatos por Instagram. Necesito envíos rápidos y una tarifa fija para no perder margen de
              ganancia en cada venta."
            </blockquote>
            <div class="recommendation-box">
              <span class="label">Recomendamos:</span>
              <span class="pack-name">Pack Crecimiento (25 guías)</span>
            </div>
          </div>
        </div>

        <div class="case-card office fadeInUp" appVisibility>
          <div class="card-accent office-accent"></div>
          <div class="case-content">
            <h3>🏢 Para Oficinas</h3>
            <blockquote class="quote-box">
              "Enviamos documentación y refacciones entre sucursales cada semana. Necesitamos control fiscal y
              facturación simple."
            </blockquote>
            <div class="recommendation-box">
              <span class="label">Recomendamos:</span>
              <span class="pack-name">Pack Empresarial (50 guías)</span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>

  <div id="pricing-area" class="pricing-anchor">
    <app-guias-web-pricing [isDynamic]="true" [restrictToTop3]="false"></app-guias-web-pricing>
    <div class="cont-trust">
      <div class="trust-footer">
        <div class="trust-item">🔒 Compra 100% Segura</div>
        <div class="trust-item">🧾 Facturación Inmediata</div>
        <div class="trust-item">🚚 Cobertura Tufesa</div>
      </div>
      <div class="container">
        <div class="disclaimer-text"
          style="font-size: 0.7rem; color: #777; text-align: center; margin-top: 30px; padding: 0 15px 30px 15px;">
          Todo envío con origen en zona fronteriza deberá presentar factura fiscal del producto antes de su traslado. En
          caso de no contar con documentación válida, el paquete no será recibido ni enviado, conforme a disposiciones
          del SAT. La empresa no se hace responsable por retrasos o retenciones derivadas del incumplimiento.
        </div>
      </div>
    </div>


  </div>

  <section class="faq-section">
    <div class="container">
      <h2 class="fadeIn" appVisibility>Preguntas Frecuentes</h2>
      <div class="faq-grid">
        <div class="faq-item fadeInUp" appVisibility>
          <h4>¿Tienen fecha de caducidad?</h4>
          <p>Sí, tienes 12 meses (1 año) completos para usar tus guías a partir de la fecha de compra.</p>
        </div>
        <div class="faq-item fadeInUp" appVisibility>
          <h4>¿Incluye recolección?</h4>
          <p>Sí, todos nuestros paquetes web incluyen servicio de recolección a domicilio sin costo extra en zonas de
            cobertura.</p>
        </div>
        <div class="faq-item fadeInUp" appVisibility>
          <h4>¿Qué pasa si mi paquete pesa más?</h4>
          <p>Si compras guías de 5kg y tu paquete pesa 7kg, podrás pagar la diferencia de sobrepeso directamente en
            mostrador o plataforma.</p>
        </div>
      </div>
    </div>
  </section>
  <!-- MODAL DE DETALLES -->
  <div class="modal-overlay" *ngIf="isModalOpen" (click)="closeDetails()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <div class="header-top">
          <h2 class="modal-title">Detalles del paquete</h2>
        </div>
        <p class="modal-subtitle">Revisa la información incluida antes de continuar</p>
        <button class="btn-close" (click)="closeDetails()">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>

      <div class="modal-body" *ngIf="selectedPkg">
        <section class="info-section">
          <h3>Qué incluye este paquete</h3>
          <div class="info-card">
            <div class="info-item">
              <i class="fa-solid fa-box icon package-icon"></i>
              <div class="info-row">
                <span class="label">Paquete:</span>
                <span class="value">{{ selectedPkg.name }}</span>
              </div>
            </div>
            <div class="info-item">
              <i class="fa-solid fa-layer-group icon qty-icon"></i>
              <div class="info-row">
                <span class="label">Cantidad:</span>
                <span class="value">{{ selectedPkg.quantity }} guías / envíos</span>
              </div>
            </div>
            <div class="info-item">
              <i class="fa-solid fa-weight-hanging icon weight-icon"></i>
              <div class="info-row">
                <span class="label">Peso máximo por envío:</span>
                <span class="value">{{ selectedPkg.weightDesc }}</span>
              </div>
            </div>
            <div class="info-item">
              <i class="fa-solid fa-clock icon time-icon"></i>
              <div class="info-row">
                <span class="label">Vigencia:</span>
                <span class="value">12 meses</span>
              </div>
            </div>

            <div class="divider"></div>

            <div class="info-item">
              <i class="fa-solid fa-hand-holding-dollar icon cost-icon"></i>
              <div class="info-row">
                <span class="label">Costo unitario:</span>
                <span class="value">${{ selectedPkg.priceUnit | number:'1.2-2' }} MXN</span>
              </div>
            </div>
            <div class="info-item">
              <i class="fa-solid fa-truck icon truck-icon"></i>
              <div class="info-row">
                <span class="label">Recolección:</span>
                <span class="value">Incluida</span>
              </div>
            </div>
            <div class="info-item">
              <i class="fa-solid fa-house-chimney icon house-icon"></i>
              <div class="info-row">
                <span class="label">Entrega:</span>
                <span class="value">Servicio a domicilio</span>
              </div>
            </div>
            <div class="info-item">
              <i class="fa-solid fa-receipt icon iva-icon"></i>
              <div class="info-row">
                <span class="label">IVA:</span>
                <span class="value">Incluido en el precio</span>
              </div>
            </div>
            <div class="info-item">
              <i class="fa-solid fa-award icon shield-icon"></i>
              <div class="info-row">
                <span class="label">Garantía:</span>
                <span class="value">Según contrato de adhesión</span>
              </div>
            </div>
          </div>
        </section>

        <section class="conditions-section">
          <h3>Condiciones del servicio</h3>
          <ul class="conditions-list">
            <li><i class="fa-solid fa-check"></i> Los costos incluyen IVA</li>
            <li><i class="fa-solid fa-check"></i> Servicio sujeto a disponibilidad de sucursales</li>
            <li><i class="fa-solid fa-check"></i> Aplica contrato de adhesión</li>
            <li><i class="fa-solid fa-xmark"></i> No incluye maniobras adicionales</li>
          </ul>
        </section>
      </div>

      <div class="modal-footer" *ngIf="selectedPkg">
        <div class="total-row">
          <div class="total-text">
            <span class="total-label">Total del paquete:</span>
          </div>
          <div class="total-amount-box">
            <span class="total-value">${{ selectedPkg.totalPrice | number:'1.2-2' }} <span
                class="total-currency">MXN</span></span>
          </div>
        </div>
        <p class="security-text">El pago se realizará de forma segura (SSL)</p>
        <div class="footer-actions">
          <a [routerLink]="['/guias-web']" [queryParams]="{ sku: selectedPkg.sku }" (click)="closeDetails()"
            class="btn-buy-modal">
            Comprar Pack
          </a>
        </div>
      </div>
    </div>
  </div>

</div>